import { BiteLogPrinterEvent } from './bite_log_printer_event.js';

export function name(event: BiteLogPrinterEvent): string {
  switch (event) {
    case BiteLogPrinterEvent.OK:
      return 'ok';
    case BiteLogPrinterEvent.ConnectError:
      return 'connect-err';
    case BiteLogPrinterEvent.ConnectTimeout:
      return 'connect-timeout';
    case BiteLogPrinterEvent.Disconnected:
      return 'disconnected';
    case BiteLogPrinterEvent.PowerOff:
      return 'power-off';
    case BiteLogPrinterEvent.AddCommandsError:
      return 'add-commands-err';
    case BiteLogPrinterEvent.SendError:
      return 'send-err';
    case BiteLogPrinterEvent.PrintJobFail:
      return 'print-job-fail';
    case BiteLogPrinterEvent.PrintJobTimeout:
      return 'print-job-timeout';
    case BiteLogPrinterEvent.CoverOpen:
      return 'cover-open';
    case BiteLogPrinterEvent.PaperLow:
      return 'paper-low';
    case BiteLogPrinterEvent.PaperEmpty:
      return 'paper-empty';
    case BiteLogPrinterEvent.PaperOK:
      return 'paper-ok';
    case BiteLogPrinterEvent.DiscoveryStartError:
      return 'discovery-start-err';
    case BiteLogPrinterEvent.CoverClosed:
      return 'cover-closed';
    case BiteLogPrinterEvent.ScannerConnectError:
      return 'scanner-connect-err';
    case BiteLogPrinterEvent.ScannerDisconnected:
      return 'scanner-disconnected';
    case BiteLogPrinterEvent.ScaleConnectError:
      return 'scale-connect-err';
    case BiteLogPrinterEvent.ScaleDisconnected:
      return 'scale-disconnected';
    case BiteLogPrinterEvent.QueueEnterFail:
      return 'queue-enter-fail';
    case BiteLogPrinterEvent.QueueCheckFail:
      return 'queue-check-fail';
    case BiteLogPrinterEvent.QueueingDisabled:
      return 'queueing-disabled';
    case BiteLogPrinterEvent.PrintJobRequested:
      return 'print-job-requested';
    case BiteLogPrinterEvent.PrintJobSucceed:
      return 'print-job-succeed';
    case BiteLogPrinterEvent.CutterError:
      return 'cutter-err';
    case BiteLogPrinterEvent.MechanicalError:
      return 'mechanical-err';
    case BiteLogPrinterEvent.AutoRecoverError:
      return 'auto-recover-err';
    case BiteLogPrinterEvent.UnrecoverableError:
      return 'unrecoverable-err';
    case BiteLogPrinterEvent.RecoverableError:
      return 'recoverable-err';
  }
}
